module.exports = __webpack_public_path__ + "img/empty-admin-console.4ebb90b5.svg";